// frontend/src/actions/projectActions.js
import axios from "../utilities/axiosInstance";
import {
  PROJECT_CREATE_REQUEST,
  PROJECT_CREATE_SUCCESS,
  PROJECT_CREATE_FAIL,
  PROJECT_CREATE_RESET,
  PROJECT_LIST_REQUEST,
  PROJECT_LIST_SUCCESS,
  PROJECT_LIST_FAIL,
  PROJECT_DETAILS_REQUEST,
  PROJECT_DETAILS_SUCCESS,
  PROJECT_DETAILS_FAIL,
  PROJECT_UPDATE_REQUEST,
  PROJECT_UPDATE_SUCCESS,
  PROJECT_UPDATE_FAIL,
  PROJECT_DELETE_REQUEST,
  PROJECT_DELETE_SUCCESS,
  PROJECT_DELETE_FAIL,
} from "../constants/projectConstants";

// Action to list projects for the logged-in developer
export const listProjects = () => async (dispatch, getState) => {
  try {
    dispatch({ type: PROJECT_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    console.log(
      "Fetching projects specific to the logged-in developer with token:",
      userInfo.token
    );
    const { data } = await axios.get("/projects/myprojects", {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });

    console.log("PROJECT_LIST_SUCCESS payload:", data);
    dispatch({ type: PROJECT_LIST_SUCCESS, payload: data });
  } catch (error) {
    console.error("Error in listProjects:", error);
    dispatch({
      type: PROJECT_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const fetchProjectDetails =
  (projectId) => async (dispatch, getState) => {
    console.log(
      "projectActions: fetchProjectDetails called with projectId:",
      projectId
    );
    try {
      dispatch({ type: PROJECT_DETAILS_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();
      const config = {
        headers: { Authorization: `Bearer ${userInfo?.token}` },
      };

      // console.log("projectActions: sending GET /api/projects/" + projectId);
      const { data } = await axios.get(`/projects/${projectId}`, config);

      console.log("projectActions: fetchProjectDetails success. data:", data);
      dispatch({ type: PROJECT_DETAILS_SUCCESS, payload: data });
    } catch (error) {
      console.error("projectActions: fetchProjectDetails error:", error);
      dispatch({
        type: PROJECT_DETAILS_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const createProject =
  (developerId, name, description) => async (dispatch, getState) => {
    try {
      dispatch({ type: PROJECT_CREATE_REQUEST });
      console.log("Creating new project for developer:", developerId);

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        "/projects",
        { developerId, name, description },
        config
      );

      console.log("Project creation success:", data);
      dispatch({ type: PROJECT_CREATE_SUCCESS, payload: data });
    } catch (error) {
      console.error("Error creating project:", error);
      dispatch({
        type: PROJECT_CREATE_FAIL,
        payload: error.response?.data?.message
          ? error.response.data.message
          : error.message,
      });
    }
  };

export const updateProject =
  (projectId, updates) => async (dispatch, getState) => {
    try {
      dispatch({ type: PROJECT_UPDATE_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.put(
        `/projects/${projectId}`,
        updates,
        config
      );
      dispatch({ type: PROJECT_UPDATE_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: PROJECT_UPDATE_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

// Delete a project (DELETE /projects/:id)
export const deleteProject = (projectId) => async (dispatch, getState) => {
  try {
    dispatch({ type: PROJECT_DELETE_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.delete(`/projects/${projectId}`, config);

    dispatch({ type: PROJECT_DELETE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: PROJECT_DELETE_FAIL,
      payload: error.response?.data?.message
        ? error.response.data.message
        : error.message,
    });
  }
};
